import moment from "moment";
import { connect } from "react-redux";
import TextButton from "../../../_components/atoms/text-button";
import Pagination from "../../../_components/pagination.component";
import { MemberTableRowShimmer } from "../invited-users-list";

function CustomPushLogList({
  setIsFormVisible,
  currentPage,
  isLoading,
  dataList,
  total,
  changePage,
  community,
  groups,
  setItemSelectedToPreview,
}) {
  function getGroupNameFromId(id) {
    let groupName = "-";
    if (!id) {
      return groupName;
    }
    groups.forEach((group) => {
      if (group.id === id) {
        groupName = group.name;
      }
    });
    return groupName;
  }

  return (
    <div className="theme-bg-surface p-4 mt-1">
      {/* send push header */}
      <div className="flex flex-col items-center place-content-center space-y-2 border border-dotted theme-border-default h-32 theme-bg-default rounded ">
        <TextButton
          label="Send Push"
          onClick={() => {
            setIsFormVisible(true);
          }}
        />
        <p className="theme-text-primary">
          Send custom push to all the members of community or selected groups
        </p>
      </div>

      {/* Table */}
      <div className="w-full mt-8 overflow-x-auto">
        <table className="table-auto min-w-full text-sm theme-text-subtitle-1 border theme-border-default w-full rounded">
          <thead className="text-xs text-left theme-text-headline-1 uppercase theme-bg-default">
            <tr>
              <th scope="col" className="px-6 pr-20 py-3">
                Date
              </th>
              <th scope="col" className="px-6 py-3">
                Subject
              </th>
              <th scope="col" className="px-6 w-36 py-3">
                To
              </th>
              <th scope="col" className="px-6 py-3">
                Recipients
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[var(--theme-border-color)]">
            {isLoading ? (
              [...Array(10)].map((_, index) => (
                <MemberTableRowShimmer key={index} />
              ))
            ) : (
              <>
                {dataList?.length > 0 ? (
                  dataList.map((data, index) => {
                    return (
                      <tr
                        key={index}
                        onClick={() => {
                          setItemSelectedToPreview(data);
                        }}
                        className="theme-bg-surface  theme-border-default hover:theme-bg-default cursor-pointer ">
                        <td className="px-6 py-2 theme-text-subtitle-1">
                          {moment(data.createdAt).fromNow()}
                        </td>
                        <td className="px-6 py-2 theme-text-subtitle-1">
                          {data.title ?? "-"}
                        </td>
                        <td className="px-6 py-2 theme-text-subtitle-1">
                          {data.group == null
                            ? community.name
                            : getGroupNameFromId(data.group)}
                        </td>
                        <td className="px-6 py-2 font-medium theme-text-headline-1 ">
                          {data.totalUsersPushedTo > 0 ? (
                            <>
                              {data.totalUsersPushedTo}{" "}
                              {data.totalUsersPushedTo > 1 ? "users" : "user"}
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr
                    className=" items-center justify-center place-content-center text-center h-32 w-full"
                    colSpan="5">
                    <td></td>
                    <td colSpan="2">No Mail</td>
                    <td></td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      {/* pagination */}
      <div>
        <Pagination
          className="pagination-bar justify-center"
          currentPage={currentPage}
          totalCount={total}
          pageSize={10}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}

export default connect((s) => ({
  community: s.community,
  groups: s.groups,
}))(CustomPushLogList);
